export const BREEDS_URL = `/api/v3/breeds/`;
export const UNKNOWN_ADORABLE_MIX = 'Unknown Adorable Mix';
